<template>
  <p-form-element class="p-phone-field">
    <p-text-field-formatted
      :value="value"
      :display-formatter="formatDisplay"
      :value-formatter="formatValue"
      :messages="innerMessages"
      :errors="innerErrors"
      :required="innerRequired"
      set-display-for-user
      v-bind="$props"
      v-on="$listeners"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
    ></p-text-field-formatted>
  </p-form-element>
</template>

<script lang="ts">
  import PTextField from '../p-text-field/p-text-field.vue';
  import validatable from '../../mixins/validatable/validatable';
  import mixins from '../../mixins';

  export default mixins(validatable).extend({
    props: {
      // TODO: Solve extension of props properly
      ...((new PTextField()).$options.props),
      value: { type: String, default: undefined },
    },
    methods: {
      formatValid(number: string | undefined) {
        return this.$format.phoneValid(number);
      },
      formatDisplay(number: string | undefined) {
        this.innerErrors = (((!this.required && (number?.length ?? 0)) === 0) || this.formatValid(number)) ? [] : [this.$t('core.phoneNumber.invalid')];
        return this.$format.phonePretty(number);
      },
      formatValue(number: string | undefined) {
        return this.$format.phoneData(number);
      },
    },
  });
</script>
